module.exports = __webpack_public_path__ + "static/assets/26534618c5fe58439c228858fb7f18b5.png";